import Link from 'next/link';
import Icon from '@/components/ui/AppIcon';

interface QuickAction {
  id: string;
  title: string;
  description: string;
  icon: string;
  link: string;
  color: string;
}

interface QuickActionsProps {
  actions: QuickAction[];
}

const QuickActions = ({ actions }: QuickActionsProps) => {
  const getColorClasses = (color: string) => {
    const colorMap: Record<string, string> = {
      primary: 'bg-primary/10 text-primary hover:bg-primary/20',
      secondary: 'bg-secondary/10 text-secondary hover:bg-secondary/20',
      accent: 'bg-accent/10 text-accent hover:bg-accent/20',
      success: 'bg-success/10 text-success hover:bg-success/20',
    };
    return colorMap[color] || colorMap.primary;
  };

  return (
    <section className="py-12 px-6 bg-muted">
      <div className="max-w-7xl mx-auto">
        <div className="mb-8">
          <h2 className="font-heading text-3xl font-bold text-foreground mb-2">
            Quick Actions
          </h2>
          <p className="text-muted-foreground">
            Fast access to your favorite features
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {actions.map((action) => (
            <Link
              key={action.id}
              href={action.link}
              className="group bg-card rounded-lg p-6 shadow-elevation-sm hover:shadow-elevation-md transition-smooth hover-lift"
            >
              <div className={`w-14 h-14 flex items-center justify-center rounded-lg mb-4 transition-smooth ${getColorClasses(action.color)}`}>
                <Icon name={action.icon as any} size={28} />
              </div>
              <h3 className="font-heading text-xl font-bold text-foreground mb-2 group-hover:text-primary transition-smooth">
                {action.title}
              </h3>
              <p className="text-muted-foreground text-sm mb-4">
                {action.description}
              </p>
              <div className="flex items-center gap-2 text-primary font-medium text-sm">
                <span>Get Started</span>
                <Icon name="ArrowRightIcon" size={16} className="group-hover:translate-x-1 transition-smooth" />
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
};

export default QuickActions;